import styled from 'styled-components';

import { ImageContainer } from 'components/features/components/empty-state/empty-state.styled';
import { LoyaltyNoRewardPoints } from 'pages/loyalty/loyalty-no-reward-points';

import {
  HistoryContainer as DefaultHistoryContainer,
  TableWrap as DefaultTableWrap,
} from './loyalty-history.styled.default';

export * from './loyalty-history.styled.default';

export const HistoryContainer = styled(DefaultHistoryContainer)`
  ${Styles.desktop} {
    max-width: 31.25rem;
    margin-block-start: 3rem;
  }
`;

export const TableWrap = styled(DefaultTableWrap)`
  border-radius: 10px;

  td {
    vertical-align: top;
  }

  ${Styles.desktop} {
    td,
    th {
      position: relative;
    }
  }
`;

export const StyledLoyaltyNoRewardPoints = styled(LoyaltyNoRewardPoints)`
  ${ImageContainer} {
    ${Styles.mobile} {
      inset-inline-start: -1.25rem;
      width: 100vw;
    }
  }
`;
